import { Controller } from "@hotwired/stimulus"

// Asks for confirmation before a form that Turbo does not handle
// (data-turbo="false") is submitted; data-turbo-confirm only works on Turbo
// forms. List confirm#ask first in data-action so a cancel stops later actions.
export default class extends Controller {
  static values = { message: String }

  ask(event) {
    if (confirm(this.messageValue)) return

    event.preventDefault()
    event.stopImmediatePropagation()
  }
}
